import { sva } from '@agapi/ui/panda/css';
export const footerStyles = sva({
    slots: ['root', 'row', 'group', 'link'],
    base: {
        root: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        row: {
            display: 'flex',
            px: 'app',
            gap: '4',
            py: '4',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            width: '100%',
            _first: {
                pt: '6',
            },
        },
        group: {
            display: 'flex',
            flexDirection: 'column',
        },
        link: {
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
    },
    variants: {
        direction: {
            row: {
                group: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '2',
                },
            },
            column: {
                group: {
                    flexDirection: 'column',
                    gap: '2',
                },
            },
        },
    },
    defaultVariants: {
        direction: 'column',
    },
});
